site.megamenu = {
	init:function() {
		var $megamenu = $('#megamenu'),
			$body = $('body');
		var $level1 = $('.mmLevel1', $megamenu);
		$('#frontpage-qn', $megamenu).attr('id', 'megamenu-links');
		$('> .ord-1', $level1).wrap('<div class="first"/>');
		$('> .ord-2, > .ord-3', $level1).wrapAll('<div class="second"/>');
		$('> .ord-4, > .ord-5', $level1).wrapAll('<div class="third"/>');
		$('> .ord-6, > .ord-7', $level1).wrapAll('<div class="fourth"/>');
		site.megamenu.setHeight();

		$('.megamenuToggle').on('click', function(e) {
			if ($body.is('.stillingar')) {
				return true;
			}

			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				$body.addClass('megamenu-open');

				$('.megamenu').removeAttr('style');

				site.megamenu.setHeight();

				$('body.megamenu-open').on('click', function (e) {
					site.megamenu.close();
				});
			}
		})
	},

	setHeight:function() {
		var $megamenu = $('#megamenu');
		if ($megamenu.length > 0) {
			var $megamenuHeight = $megamenu[0].scrollHeight + 5;
			$megamenu.css('max-height', $megamenuHeight);
		}
	},

	close:function() {
		var $body = $('body');

		if ($body.hasClass('megamenu-open')) {
			$body.addClass('megamenu-closing');
			setTimeout(function() {
				$body.removeClass('megamenu-closing');
			},400);
		}
		$body.removeClass('megamenu-open');
	}
};
